import React, { FC } from 'react';
import { DialogTitle } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { ClientLogo } from 'components';

interface IProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    title: {
      margin: 0,
      borderBottom: `1px solid ${theme.custom.palette.grey3}`,
      zIndex: 1,
    },
  });

const Title: FC<IProps> = ({ classes }) => (
  <DialogTitle className={classes.title}>
    <ClientLogo height={24} disableMargin />
  </DialogTitle>
);

export default withStyles(styles)(Title);
